import React from 'react'
import {
  ModalContent,
  ModalTitle,
  ModalFooter,
  Button,
  Paragraph,
} from 'suomifi-ui-components'
import LocalizedString from 'todistukset-ui/src/vtj/components/localized-string/LocalizedString.react'
import { setPreviousAddressDialogDismissed } from 'todistukset-ui/src/vtj/stores/actions/common-actions'
import type { DialogItem } from 'todistukset-ui/src/vtj/stores/dialogs.mobx.store'

export const TranslationFormWithPreviousAddressesDialogContent = ({
  dialogItem,
}: {
  dialogItem: DialogItem
}): React.JSX.Element => {
  return (
    <React.Fragment>
      <ModalContent data-test-id={`${dialogItem.id}-dialog-body`}>
        <ModalTitle>
          <LocalizedString stringKey="translationFormWithPreviousAddressesDialogTitle" />
        </ModalTitle>
        <Paragraph>
          <LocalizedString stringKey="translationFormWithPreviousAddressesDialogContent" />
        </Paragraph>
      </ModalContent>
      <ModalFooter>
        <Button
          onClick={(): void => {
            setPreviousAddressDialogDismissed(true)
            dialogItem.active?.resolveDialog('closeTranslationFormInfoBox')
          }}
        >
          <LocalizedString stringKey="close" />
        </Button>
      </ModalFooter>
    </React.Fragment>
  )
}
